import styled from 'styled-components';


/*
====================================
COLORES YÖGEN
====================================

Paleta fija del proyecto:

#D76970  rojo/rosa
#655EE8  violeta
#EFC340  amarillo
#23AAAF  turquesa
#FC8906  naranja
#646464  gris
====================================
*/


/*
====================================
CONTENEDOR GENERAL
====================================
*/

export const EstadisticasMain = styled.main`
    width: 96%;
    max-width: 1400px;

    margin: 0 auto;
    padding: 1rem 0 3rem 0;

    color: #263434;

    @media (max-width: 700px) {
        width: 94%;
        padding-top: 0.8rem;
    }
`;


/*
====================================
CABECERA INTERNA
====================================
*/

export const EstadisticasCabecera = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;

    gap: 1rem;

    margin-bottom: 0.8rem;

    @media (max-width: 700px) {
        flex-direction: column;
        align-items: flex-start;
    }
`;

export const EstadisticasTituloContenedor = styled.div`
    display: flex;
    align-items: baseline;
    gap: 0.8rem;

    @media (max-width: 600px) {
        flex-direction: column;
        gap: 0.2rem;
    }
`;

export const EstadisticasTitulo = styled.h1`
    margin: 0;

    font-size: 1.55rem;
    font-weight: 700;

    color: #263434;
`;


export const EstadisticasSubtitulo = styled.div`
    font-size: 0.85rem;
    color: #646464;
`;


/*
====================================
ACCIONES PRINCIPALES
====================================
*/

export const AccionesCabecera = styled.div`
    display: flex;
    align-items: center;

    gap: 0.7rem;

    @media (max-width: 700px) {
        width: 100%;
    }
`;


export const BotonPrincipal = styled.button`
    border: none;
    border-radius: 9px;

    background-color: #23AAAF;
    color: white;

    padding: 0.7rem 1rem;

    font-weight: 600;
    font-family: 'Montserrat', sans-serif;

    cursor: pointer;

    transition: 0.2s;

    &:hover {
        background-color: #18898D;
    }

    &:disabled {
        opacity: 0.5;
        cursor: not-allowed;
    }

    @media (max-width: 700px) {
        flex: 1;
    }
`;


export const BotonSecundario = styled.button`
    border: 1px solid #23AAAF;
    border-radius: 9px;

    background-color: white;
    color: #18898D;

    padding: 0.65rem 1rem;

    font-weight: 600;
    font-family: 'Montserrat', sans-serif;

    cursor: pointer;

    transition: 0.2s;

    &:hover {
        background-color: #E6F7F7;
    }

    @media (max-width: 700px) {
        flex: 1;
    }
`;


/*
====================================
FILTROS DE PERÍODO
====================================
*/

export const ContenedorFiltros = styled.div`
    display: flex;
    align-items: center;

    gap: 0.5rem;

    flex-wrap: wrap;

    background-color: #FFFFFF;

    border: 1px solid #E3E9E8;
    border-radius: 12px;

    padding: 0.45rem 0.65rem;

    margin-bottom: 0.75rem;
`;


export const GrupoPeriodos = styled.div`
    display: flex;

    gap: 0.15rem;

    background-color: #F5F7F7;

    padding: 0.15rem;

    border-radius: 9px;

    @media (max-width: 700px) {
        width: 100%;
        overflow-x: auto;
    }
`;


export const BotonPeriodo = styled.button`
    border: none;
    border-radius: 7px;

    padding: 0.42rem 0.75rem;

    white-space: nowrap;

    font-family: 'Montserrat', sans-serif;
    font-size: 0.75rem;
    font-weight: 600;

    cursor: pointer;

    background-color: ${props =>
        props.$activo
            ? '#23AAAF'
            : 'transparent'};

    color: ${props =>
        props.$activo
            ? '#FFFFFF'
            : '#646464'};

    transition: 0.2s;
`;


export const PeriodoTexto = styled.div`
    margin-left: auto;

    font-size: 0.78rem;
    color: #646464;

    @media (max-width: 700px) {
        width: 100%;
        margin-left: 0;
    }
`;

/*
====================================
FECHAS PERSONALIZADAS
====================================
*/

export const FechasPersonalizadas = styled.div`
    display: flex;
    align-items: center;

    gap: 0.5rem;

    margin-left: 0.3rem;

    @media (max-width: 700px) {
        width: 100%;
        margin-left: 0;
    }
`;


export const FechaPersonalizadaGrupo = styled.div`
    display: flex;
    align-items: center;

    gap: 0.3rem;
`;


export const FechaPersonalizadaLabel = styled.label`
    font-size: 0.65rem;
    font-weight: 600;

    color: #737F7F;
`;


export const FechaPersonalizadaInput = styled.input`
    box-sizing: border-box;

    border: 1px solid #DDE4E3;
    border-radius: 7px;

    background-color: #FFFFFF;

    padding: 0.38rem 0.45rem;

    font-family: 'Montserrat', sans-serif;
    font-size: 0.7rem;

    color: #263434;

    outline: none;

    &:focus {
        border-color: #23AAAF;
    }
`;


/*
====================================
TARJETAS KPI
====================================
*/

export const GridKpis = styled.div`
    display: grid;

    grid-template-columns:
        repeat(4, minmax(0, 1fr));

    gap: 0.65rem;

    margin-bottom: 0.65rem;

    @media (max-width: 800px) {
        grid-template-columns:
            repeat(2, minmax(0, 1fr));
    }

    @media (max-width: 500px) {
        grid-template-columns: 1fr;
    }
`;


export const TarjetaKpi = styled.div`
    position: relative;
    overflow: hidden;

    background-color: #FFFFFF;

    border: 1px solid #E3E9E8;
    border-radius: 12px;

    padding: 0.8rem 0.9rem;

    &::before {
        content: '';

        position: absolute;

        left: 0;
        top: 0;
        bottom: 0;

        width: 4px;

        background-color:
            ${props =>
                props.$color || '#23AAAF'};
    }
`;

export const KpiTitulo = styled.div`
    font-size: 0.68rem;
    font-weight: 700;

    text-transform: uppercase;

    letter-spacing: 0.04rem;

    color: #737F7F;
`;


export const KpiValor = styled.div`
    margin-top: 0.25rem;

    font-size: 1.55rem;
    font-weight: 700;

    color: #263434;
`;


export const KpiDetalle = styled.div`
    margin-top: 0.2rem;

    font-size: 0.72rem;

    color: #737F7F;
`;


/*
====================================
RESUMEN ECONÓMICO
====================================
*/

export const GridEconomia = styled.div`
    display: grid;

    grid-template-columns:
        repeat(5, minmax(0, 1fr));

    gap: 0.6rem;

    margin-bottom: 0.75rem;

    @media (max-width: 850px) {
        grid-template-columns:
            repeat(3, minmax(0, 1fr));
    }

    @media (max-width: 650px) {
        grid-template-columns:
            repeat(2, minmax(0, 1fr));
    }

    @media (max-width: 430px) {
        grid-template-columns: 1fr;
    }
`;


export const TarjetaEconomia = styled.div`
    background-color: #FFFFFF;

    border: 1px solid #E3E9E8;
    border-radius: 12px;

    padding: 0.75rem 0.8rem;

    min-width: 0;
`;


export const EconomiaTitulo = styled.div`
    display: flex;
    align-items: center;

    gap: 0.35rem;

    font-size: 0.62rem;
    font-weight: 700;

    text-transform: uppercase;

    letter-spacing: 0.03rem;

    color: #737F7F;

    white-space: nowrap;
`;


export const PuntoColor = styled.span`
    width: 9px;
    height: 9px;

    border-radius: 3px;

    flex-shrink: 0;

    background-color:
        ${props =>
            props.$color || '#23AAAF'};
`;


export const EconomiaValor = styled.div`
    margin-top: 0.25rem;

    font-size: 1rem;
    font-weight: 700;

    color: #263434;

    white-space: nowrap;
`;


export const EconomiaDetalle = styled.div`
    margin-top: 0.15rem;

    font-size: 0.64rem;

    color: #737F7F;
`;


/*
====================================
AVISO DE DEUDA ANTERIOR
====================================
*/

export const AvisoDeuda = styled.div`
    display: flex;
    align-items: center;

    gap: 0.8rem;

    background-color: #FBEDEF;

    border: 1px solid #F1D5D8;
    border-radius: 11px;

    padding: 0.8rem 1rem;

    margin-bottom: 1rem;
`;


export const AvisoDeudaIcono = styled.div`
    width: 32px;
    height: 32px;

    display: flex;
    align-items: center;
    justify-content: center;

    flex-shrink: 0;

    border-radius: 9px;

    background-color: #FFFFFF;

    color: #D76970;

    font-weight: 700;
`;


export const AvisoDeudaContenido = styled.div`
    flex: 1;
`;


export const AvisoDeudaTitulo = styled.div`
    font-size: 0.8rem;
    font-weight: 700;

    color: #763A3F;
`;


export const AvisoDeudaTexto = styled.div`
    margin-top: 0.15rem;

    font-size: 0.7rem;

    color: #785C5E;
`;


/*
====================================
PANELES
====================================
*/

export const GridPaneles = styled.div`
    display: grid;

    grid-template-columns:
        minmax(0, 0.9fr)
        minmax(0, 1.1fr);

    gap: 0.65rem;

    margin-bottom: 1rem;

    @media (max-width: 850px) {
        grid-template-columns: 1fr;
    }
`;

export const Panel = styled.div`
    background-color: #FFFFFF;

    border: 1px solid #E3E9E8;
    border-radius: 12px;

    padding: 0.8rem 0.9rem;
`;


export const PanelCabecera = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;

    gap: 0.5rem;

    margin-bottom: 0.65rem;
`;


export const PanelTitulo = styled.div`
    font-size: 0.85rem;
    font-weight: 700;

    color: #263434;
`;


export const PanelSubtitulo = styled.div`
    font-size: 0.68rem;

    color: #737F7F;
`;


/*
====================================
GRÁFICO PRESENTISMO
====================================
*/

export const PresentismoContenido = styled.div`
    display: flex;
    align-items: center;

    gap: 1.1rem;

    @media (max-width: 500px) {
        flex-direction: column;
    }
`;


export const GraficoPresentismo = styled.div`
    width: 105px;
    height: 105px;

    flex-shrink: 0;

    display: flex;
    align-items: center;
    justify-content: center;

    border-radius: 50%;

    background: ${({ $porcentaje }) => {
        const porcentaje = Math.min(
            Math.max(
                Number($porcentaje || 0),
                0
            ),
            100
        );

        return `
            conic-gradient(
                #23AAAF 0% ${porcentaje}%,
                #EEF2F2 ${porcentaje}% 100%
            )
        `;
    }};

    position: relative;

    &::after {
        content: '';

        position: absolute;

        width: 73px;
        height: 73px;

        background-color: #FFFFFF;

        border-radius: 50%;
    }
`;


export const GraficoPresentismoTexto = styled.div`
    position: relative;

    z-index: 1;

    text-align: center;
`;


export const GraficoPresentismoValor = styled.div`
    font-size: 1.25rem;
    font-weight: 700;

    color: #23AAAF;
`;


export const GraficoPresentismoLabel = styled.div`
    margin-top: 0.1rem;

    font-size: 0.6rem;
    font-weight: 700;

    text-transform: uppercase;

    color: #737F7F;
`;


/*
====================================
LEYENDA ASISTENCIA
====================================
*/

export const ListaAsistencia = styled.div`
    display: flex;
    flex-direction: column;

    gap: 0.45rem;

    flex: 1;
`;


export const ItemAsistencia = styled.div`
    display: flex;
    align-items: center;

    gap: 0.5rem;

    font-size: 0.75rem;

    color: #646464;
`;


export const ItemAsistenciaValor = styled.strong`
    margin-left: auto;

    color: #263434;
`;


/*
====================================
FILAS ECONÓMICAS
====================================
*/

export const FilaEconomia = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;

    gap: 1rem;

    padding: 0.38rem 0;

    border-bottom: 1px solid #EAEDED;

    &:last-child {
        border-bottom: none;
    }
`;


export const FilaEconomiaNombre = styled.div`
    font-size: 0.75rem;

    color: #737F7F;
`;


export const FilaEconomiaValor = styled.div`
    font-size: 0.8rem;
    font-weight: 700;

    color:
        ${props =>
            props.$color || '#263434'};
`;


/*
====================================
PROGRESO DE COBRANZA
====================================
*/

export const BarraProgreso = styled.div`
    width: 100%;
    height: 7px;

    margin-top: 0.65rem;

    overflow: hidden;

    border-radius: 20px;

    background-color: #EEF2F2;
`;


export const BarraProgresoInterna = styled.div`
    width: ${({ $porcentaje }) => {
        const porcentaje = Number($porcentaje || 0);

        const porcentajeLimitado = Math.min(
            Math.max(porcentaje, 0),
            100
        );

        return `${porcentajeLimitado}%`;
    }};

    height: 100%;

    border-radius: 20px;

    background-color: #23AAAF;
`;


export const BarraProgresoDetalle = styled.div`
    display: flex;
    justify-content: space-between;

    gap: 0.5rem;

    margin-top: 0.4rem;

    font-size: 0.68rem;

    color: #737F7F;
`;


/*
====================================
SECCIÓN TURNOS
====================================
*/

export const SeccionTitulo = styled.div`
    margin-top: 0.6rem;
    margin-bottom: 0.5rem;
`;


export const SeccionTituloPrincipal = styled.h2`
    margin: 0;

    font-size: 0.95rem;
    font-weight: 700;

    color: #263434;
`;


export const SeccionTituloSecundario = styled.div`
    margin-top: 0.2rem;

    font-size: 0.72rem;

    color: #737F7F;
`;


/*
====================================
TABLA
====================================
*/

export const TablaContenedor = styled.div`
    width: 100%;

    overflow-x: auto;

    background-color: #FFFFFF;

    border: 1px solid #E3E9E8;
    border-radius: 12px;
`;


export const TablaTurnos = styled.table`
    width: 100%;
    min-width: 900px;

    border-collapse: collapse;

    font-size: 0.75rem;

    thead {
        background-color: #FAFBFB;
    }

    th {
        padding: 0.55rem 0.7rem;

        text-align: left;

        font-size: 0.62rem;
        font-weight: 700;

        text-transform: uppercase;

        letter-spacing: 0.03rem;

        color: #737F7F;

        border-bottom: 1px solid #E3E9E8;
    }

    td {
        padding: 0.55rem 0.7rem;

        color: #263434;

        border-bottom: 1px solid #EAEDED;
    }

    tbody tr:last-child td {
        border-bottom: none;
    }

    tbody tr {
        cursor: pointer;
        transition: 0.15s;
    }

    tbody tr:hover {
        background-color: #F5FAFA;
    }

    tbody tr:focus {
        outline: 2px solid #23AAAF;
        outline-offset: -2px;
    }
`;


/*
====================================
ESTADOS
====================================
*/

export const EstadoBadge = styled.span`
    display: inline-flex;
    align-items: center;

    padding: 0.28rem 0.5rem;

    border-radius: 20px;

    white-space: nowrap;

    font-size: 0.65rem;
    font-weight: 700;

    background-color:
        ${props => {

            switch (props.$tipo) {

                case 'REALIZADO':
                    return '#E6F7F7';

                case 'CANCELADO':
                    return '#FBEDEF';

                case 'NO_ASISTIO':
                    return '#FFF0DE';

                case 'PENDIENTE':
                    return '#FFF7D9';

                case 'COBRADO':
                    return '#EAF6F0';

                case 'PARCIAL':
                    return '#FFF7D9';

                case 'NO_COBRABLE':
                    return '#F1F2F2';

                default:
                    return '#F1F2F2';
            }

        }};

    color:
        ${props => {

            switch (props.$tipo) {

                case 'REALIZADO':
                    return '#18898D';

                case 'CANCELADO':
                    return '#B45059';

                case 'NO_ASISTIO':
                    return '#B76400';

                case 'PENDIENTE':
                    return '#92720A';

                case 'COBRADO':
                    return '#357F61';

                case 'PARCIAL':
                    return '#92720A';

                case 'NO_COBRABLE':
                    return '#646464';

                default:
                    return '#646464';
            }

        }};
`;


/*
====================================
IMPORTE
====================================
*/

export const Importe = styled.span`
    font-weight: 700;

    color: #263434;
`;


/*
====================================
BOTÓN ACCIÓN TABLA
====================================
*/

export const BotonDetalle = styled.button`
    width: 30px;
    height: 30px;

    display: flex;
    align-items: center;
    justify-content: center;

    border: 1px solid #DDE4E3;
    border-radius: 8px;

    background-color: #FFFFFF;

    color: #18898D;

    font-size: 1rem;
    font-weight: 700;

    cursor: pointer;

    transition: 0.2s;

    &:hover {
        border-color: #E6F7F7;
        background-color: #E6F7F7;
    }
`;


/*
====================================
SIN INFORMACIÓN
====================================
*/

export const SinInformacion = styled.div`
    padding: 2rem;

    text-align: center;

    color: #737F7F;

    font-size: 0.8rem;
`;


/*
====================================
CARGANDO
====================================
*/

export const CargandoEstadisticas = styled.div`
    padding: 3rem 1rem;

    text-align: center;

    color: #646464;
`;

/*
====================================
MODAL DETALLE ECONÓMICO
====================================
*/

export const ModalEconomiaContenido = styled.div`
    width: 100%;
    max-width: 650px;

    box-sizing: border-box;

    background-color: #FFFFFF;

    border-radius: 12px;

    padding: 1.2rem;

    font-family: 'Montserrat', sans-serif;
`;


export const ModalEconomiaCabecera = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: flex-start;

    gap: 1rem;

    padding-bottom: 0.8rem;

    border-bottom: 1px solid #E3E9E8;
`;


export const ModalEconomiaTitulo = styled.h2`
    margin: 0;

    font-size: 1.1rem;
    font-weight: 700;

    color: #263434;
`;


export const ModalEconomiaSubtitulo = styled.div`
    margin-top: 0.25rem;

    font-size: 0.72rem;

    color: #737F7F;
`;


export const BotonCerrarModal = styled.button`
    border: none;
    background: transparent;

    color: #646464;

    font-size: 1.2rem;

    cursor: pointer;
`;


/*
====================================
RESUMEN DEL TURNO
====================================
*/

export const ModalResumenGrid = styled.div`
    display: grid;

    grid-template-columns:
        repeat(4, minmax(0, 1fr));

    gap: 0.6rem;

    margin-top: 1rem;

    @media (max-width: 650px) {
        grid-template-columns:
            repeat(2, minmax(0, 1fr));
    }
`;


export const ModalResumenItem = styled.div`
    background-color: #F7F9F9;

    border-radius: 9px;

    padding: 0.7rem;
`;


export const ModalResumenLabel = styled.div`
    font-size: 0.6rem;
    font-weight: 700;

    text-transform: uppercase;

    color: #737F7F;
`;


export const ModalResumenValor = styled.div`
    margin-top: 0.25rem;

    font-size: 0.78rem;
    font-weight: 700;

    color: #263434;
`;


/*
====================================
SECCIÓN DEL MODAL
====================================
*/

export const ModalSeccion = styled.div`
    margin-top: 1.2rem;
`;


export const ModalSeccionTitulo = styled.div`
    margin-bottom: 0.5rem;

    font-size: 0.7rem;
    font-weight: 700;

    text-transform: uppercase;

    color: #737F7F;
`;


export const ModalFila = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;

    gap: 1rem;

    padding: 0.55rem 0;

    border-bottom: 1px solid #EAEDED;

    &:last-child {
        border-bottom: none;
    }
`;


export const ModalFilaNombre = styled.div`
    font-size: 0.75rem;

    color: #737F7F;
`;


export const ModalFilaValor = styled.div`
    font-size: 0.78rem;
    font-weight: 700;

    color: #263434;
`;


/*
====================================
AVISO MODAL
====================================
*/

export const ModalAviso = styled.div`
    margin-top: 1rem;

    padding: 0.7rem 0.8rem;

    border-radius: 9px;

    background-color: #EFEEFD;

    color: #514B9A;

    font-size: 0.7rem;

    line-height: 1.4;
`;


/*
====================================
ACCIONES MODAL
====================================
*/

export const ModalAcciones = styled.div`
    display: flex;
    justify-content: flex-end;

    gap: 0.6rem;

    margin-top: 1.2rem;
`;

/*
====================================
HISTORIAL DE COBROS
====================================
*/

export const HistorialLista = styled.div`
    display: flex;
    flex-direction: column;

    gap: 0.7rem;

    margin-top: 1rem;
`;


export const HistorialPago = styled.div`
    border: 1px solid #E3E9E8;
    border-radius: 10px;

    padding: 0.8rem;

    background-color: #FFFFFF;
`;


export const HistorialPagoCabecera = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: flex-start;

    gap: 1rem;
`;


export const HistorialPagoFecha = styled.div`
    font-size: 0.78rem;
    font-weight: 700;

    color: #263434;
`;


export const HistorialPagoMeta = styled.div`
    margin-top: 0.2rem;

    font-size: 0.68rem;

    color: #737F7F;
`;


export const HistorialPagoImporte = styled.div`
    font-size: 1rem;
    font-weight: 700;

    color: #263434;

    white-space: nowrap;
`;


export const HistorialPagoEstado = styled.span`
    display: inline-flex;

    margin-top: 0.3rem;

    padding: 0.25rem 0.5rem;

    border-radius: 20px;

    font-size: 0.62rem;
    font-weight: 700;

    background-color: ${props =>
        props.$anulado
            ? '#FBEDEF'
            : '#E6F7F7'};

    color: ${props =>
        props.$anulado
            ? '#B45059'
            : '#18898D'};
`;


export const HistorialResumen = styled.div`
    display: grid;

    grid-template-columns:
        repeat(3, minmax(0, 1fr));

    gap: 0.5rem;

    margin-top: 0.75rem;

    @media (max-width: 600px) {
        grid-template-columns: 1fr;
    }
`;


export const HistorialResumenItem = styled.div`
    background-color: #F7F9F9;

    border-radius: 8px;

    padding: 0.55rem 0.65rem;
`;


export const HistorialResumenLabel = styled.div`
    font-size: 0.58rem;
    font-weight: 700;

    text-transform: uppercase;

    color: #737F7F;
`;


export const HistorialResumenValor = styled.div`
    margin-top: 0.2rem;

    font-size: 0.75rem;
    font-weight: 700;

    color: #263434;
`;


export const HistorialImputaciones = styled.div`
    margin-top: 0.7rem;
`;


export const HistorialImputacion = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;

    gap: 1rem;

    padding: 0.45rem 0;

    border-bottom: 1px solid #EAEDED;

    font-size: 0.68rem;

    &:last-child {
        border-bottom: none;
    }
`;


export const HistorialObservacion = styled.div`
    margin-top: 0.7rem;

    padding: 0.55rem 0.65rem;

    background-color: #F7F9F9;

    border-radius: 8px;

    font-size: 0.68rem;
    color: #646464;
`;

/*
====================================
SCROLL HISTORIAL
====================================

Permite recorrer muchos cobros sin
mostrar la barra de scroll.

El encabezado y las acciones del modal
quedan fuera de esta zona.
====================================
*/

export const HistorialScroll = styled.div`
    max-height: calc(90vh - 165px);

    overflow-y: auto;
    overflow-x: hidden;

    padding-right: 0.15rem;

    scrollbar-width: none;

    &::-webkit-scrollbar {
        display: none;
    }
`;

/*
====================================
REGISTRAR COBRO
====================================
*/

export const CobroFormulario = styled.div`
    margin-top: 1rem;
`;


export const CobroCamposGrid = styled.div`
    display: grid;

    grid-template-columns:
        repeat(2, minmax(0, 1fr));

    gap: 0.7rem;

    @media (max-width: 600px) {
        grid-template-columns: 1fr;
    }
`;


export const CobroCampo = styled.div`
    display: flex;
    flex-direction: column;

    gap: 0.3rem;
`;


export const CobroLabel = styled.label`
    font-size: 0.65rem;
    font-weight: 700;

    text-transform: uppercase;

    color: #737F7F;
`;


export const CobroInput = styled.input`
    box-sizing: border-box;

    width: 100%;

    border: 1px solid #DDE4E3;
    border-radius: 8px;

    padding: 0.6rem 0.7rem;

    font-family: 'Montserrat', sans-serif;
    font-size: 0.75rem;

    color: #263434;

    outline: none;

    &:focus {
        border-color: #23AAAF;
    }
`;


export const CobroSelect = styled.select`
    box-sizing: border-box;

    width: 100%;

    border: 1px solid #DDE4E3;
    border-radius: 8px;

    padding: 0.6rem 0.7rem;

    background-color: #FFFFFF;

    font-family: 'Montserrat', sans-serif;
    font-size: 0.75rem;

    color: #263434;

    outline: none;

    &:focus {
        border-color: #23AAAF;
    }
`;


export const CobroTextarea = styled.textarea`
    box-sizing: border-box;

    width: 100%;
    min-height: 70px;

    resize: vertical;

    border: 1px solid #DDE4E3;
    border-radius: 8px;

    padding: 0.6rem 0.7rem;

    font-family: 'Montserrat', sans-serif;
    font-size: 0.75rem;

    color: #263434;

    outline: none;

    &:focus {
        border-color: #23AAAF;
    }
`;


/*
====================================
CARGOS A COBRAR
====================================
*/

export const CargosLista = styled.div`
    display: flex;
    flex-direction: column;

    gap: 0.45rem;

    margin-top: 0.6rem;
`;


export const CargoSeleccionable = styled.label`
    display: grid;

    grid-template-columns:
        auto
        minmax(0, 1fr)
        auto;

    align-items: center;

    gap: 0.7rem;

    padding: 0.65rem 0.75rem;

    border: 1px solid
        ${props =>
            props.$seleccionado
                ? '#23AAAF'
                : '#E3E9E8'};

    border-radius: 9px;

    background-color:
        ${props =>
            props.$seleccionado
                ? '#F0FAFA'
                : '#FFFFFF'};

    cursor: pointer;
`;


export const CargoCheckbox = styled.input`
    width: 16px;
    height: 16px;

    accent-color: #23AAAF;

    cursor: pointer;
`;


export const CargoDatos = styled.div`
    min-width: 0;
`;


export const CargoFecha = styled.div`
    font-size: 0.75rem;
    font-weight: 700;

    color: #263434;
`;


export const CargoDetalle = styled.div`
    margin-top: 0.15rem;

    font-size: 0.65rem;

    color: #737F7F;
`;


export const CargoSaldo = styled.div`
    text-align: right;

    white-space: nowrap;
`;


export const CargoSaldoLabel = styled.div`
    font-size: 0.58rem;
    font-weight: 700;

    text-transform: uppercase;

    color: #737F7F;
`;


export const CargoSaldoValor = styled.div`
    margin-top: 0.15rem;

    font-size: 0.8rem;
    font-weight: 700;

    color: #263434;
`;


export const CobroTotalSeleccionado = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;

    gap: 1rem;

    margin-top: 0.7rem;

    padding: 0.7rem 0.8rem;

    border-radius: 9px;

    background-color: #F7F9F9;
`;


export const CobroTotalLabel = styled.div`
    font-size: 0.68rem;
    color: #737F7F;
`;


export const CobroTotalValor = styled.div`
    font-size: 0.9rem;
    font-weight: 700;

    color: #263434;
`;

/*
====================================
SCROLL CONTENIDO MODAL
====================================

Permite desplazar el contenido interno
sin mostrar la barra de scroll.

La cabecera y los botones quedan
siempre visibles.
====================================
*/

export const ModalScrollContenido = styled.div`
    max-height: calc(90vh - 175px);

    overflow-y: auto;
    overflow-x: hidden;

    padding-right: 0.15rem;

    scrollbar-width: none;

    &::-webkit-scrollbar {
        display: none;
    }
`;

/*
====================================
ACCIONES DE UN PAGO
====================================
*/

export const HistorialPagoAcciones = styled.div`
    display: flex;
    justify-content: flex-end;

    margin-top: 0.7rem;
`;

/*
====================================
ACCIÓN TARJETA ECONÓMICA
====================================
*/

export const BotonAccionEconomia = styled.button`
    margin-top: 0.5rem;

    border: 1px solid #FC8906;
    border-radius: 7px;

    background-color: #FFFFFF;
    color: #C86900;

    padding: 0.35rem 0.55rem;

    font-family: 'Montserrat', sans-serif;
    font-size: 0.62rem;
    font-weight: 700;

    cursor: pointer;

    transition: 0.2s;

    &:hover {
        background-color: #FFF4E7;
    }

    &:disabled {
        opacity: 0.5;
        cursor: not-allowed;
    }
`;

/*
====================================
BOTÓN ORDEN TABLA
====================================
*/

export const BotonOrdenTabla = styled.button`
    width: 100%;

    border: none;
    background: transparent;

    padding: 0;

    color: inherit;

    font-family: inherit;
    font-size: inherit;
    font-weight: inherit;

    text-align: left;

    cursor: pointer;

    white-space: nowrap;

    &:hover {
        color: #655EE8;
    }
`;

/*
====================================
BUSCADOR RESUMEN PACIENTES
====================================
*/

export const BuscadorPacientes = styled.input`
    width: 220px;
    max-width: 100%;

    flex-shrink: 0;

    border: 1px solid #D9E0E0;
    border-radius: 8px;

    background-color: #FFFFFF;

    padding: 0.48rem 0.7rem;

    font-family: 'Montserrat', sans-serif;
    font-size: 0.7rem;

    color: #263333;

    outline: none;

    &:focus {
        border-color: #23AAAF;
    }

    &::placeholder {
        color: #98A2A2;
    }

    @media (max-width: 850px) {
        width: 100%;
    }
`;

/*
====================================
BARRA RESUMEN PACIENTES
====================================

Agrupa los filtros administrativos
y el buscador de pacientes.
====================================
*/

export const BarraResumenPacientes = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 1rem;

    margin-bottom: 0.55rem;

    @media (max-width: 850px) {
        align-items: stretch;
        flex-direction: column;
        gap: 0.55rem;
    }
`;

/*
====================================
BOTÓN AYUDA CONCEPTOS
====================================
*/

export const BotonAyudaConceptos = styled.button`
    width: 22px;
    height: 22px;

    display: inline-flex;
    align-items: center;
    justify-content: center;

    flex-shrink: 0;

    border: 1px solid #BFC9C9;
    border-radius: 50%;

    background-color: #FFFFFF;

    color: #646464;

    font-family: 'Montserrat', sans-serif;
    font-size: 0.7rem;
    font-weight: 700;

    cursor: pointer;

    transition: all 0.15s ease;

    &:hover {
        border-color: #23AAAF;
        color: #23AAAF;
    }

    &:focus {
        outline: 2px solid rgba(35, 170, 175, 0.2);
        outline-offset: 2px;
    }
`;

/*
====================================
SELECTOR PRINCIPAL
PACIENTES / CENTROS
====================================
*/

export const SelectorModuloContenedor = styled.div`

    width: 96%;
    max-width: 1400px;

    margin: 0 auto;

    padding-top: 0.8rem;

    display: flex;
    align-items: center;

    gap: 0.35rem;

    border-bottom: 1px solid #E3E9E8;


    @media (max-width: 700px) {

        width: 94%;

        overflow-x: auto;

    }

`;


export const SelectorModuloBoton = styled.button`

    position: relative;

    border: none;

    background: transparent;

    padding: 0.65rem 0.9rem;

    font-family: 'Montserrat', sans-serif;

    font-size: 0.78rem;
    font-weight: 700;

    white-space: nowrap;

    cursor: pointer;

    color:
        ${props =>
            props.$activo
                ? '#18898D'
                : '#737F7F'};


    &::after {

        content: '';

        position: absolute;

        left: 0;
        right: 0;
        bottom: -1px;

        height: 3px;

        border-radius: 3px 3px 0 0;

        background-color:
            ${props =>
                props.$activo
                    ? '#23AAAF'
                    : 'transparent'};

    }


    &:hover {

        color: #18898D;

    }

`;